export const BASE_URL = process.env.REACT_APP_API_URL
const API_URL = BASE_URL + "/api";

const getToken = () => localStorage.getItem("access_token");

async function handleResponse(res) {
  // prova a leggere JSON, ma se non è JSON ritorna solo lo status
  try {
    const data = await res.json();
    return { ok: res.ok, ...data };
  } catch {
    return { ok: res.ok };
  }
}

async function fetchWithRefresh(url, options = {}) {
  let token = getToken();
  if (!options.headers) options.headers = {};
  options.headers['Authorization'] = `Bearer ${token}`;

  if (!(options.body instanceof FormData) && !options.headers['Content-Type']) {
    options.headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(url, options);

  // Se il token è scaduto o non valido → logout e redirect
  if (res.status === 401) {
    localStorage.removeItem("access_token");
    window.location.href = "/"; // o "/login" se preferisci
    return { ok: false, message: "Token scaduto" };
  }

  return handleResponse(res);
}

// Auth
export async function login(credentials) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });

  const data = await handleResponse(res);

  if (data.ok) {
    localStorage.setItem("access_token", data.access_token);
  }

  return data;
}

export async function register(user) {
  const res = await fetch(`${API_URL}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  });
  return handleResponse(res);
}

export function logout() {
  localStorage.removeItem("access_token");
  return { ok: true };
}

// Dashboard
export function getStats() {
  return fetchWithRefresh(`${API_URL}/dashboard/stats`);
}

// Participants
export function getCoachParticipants() {
  return fetchWithRefresh(`${API_URL}/participants/`);
}

export function createCoachParticipant(participant) {
  return fetchWithRefresh(`${API_URL}/participants/`, {
    method: "POST",
    body: JSON.stringify(participant),
  });
}

export function updateCoachParticipant(id, participant) {
  return fetchWithRefresh(`${API_URL}/participants/${id}`, {
    method: "PUT",
    body: JSON.stringify(participant),
  });
}

export function deleteCoachParticipant(id) {
  return fetchWithRefresh(`${API_URL}/participants/${id}`, {
    method: "DELETE",
  });
}

export function getDisciplines() {
  return fetchWithRefresh(`${API_URL}/disciplines/`);
}

// Excel
export async function downloadParticipantsExcel() {
  const token = getToken();
  const res = await fetch(`${API_URL}/scripts/partecipanti`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || "Errore nel download");
  }

  return await res.blob();
}

export async function uploadAbbinamentiExcel(file) {
  const token = getToken();
  const formData = new FormData();
  formData.append("excel_file", file);

  const res = await fetch(`${API_URL}/scripts/abbinamenti`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` }, // niente Content-Type
    body: formData,
  });

  return res;
}

export function getMatches() {
  return fetchWithRefresh(`${API_URL}/matches/`);
}

export async function loadMatch(areaId, categoria) {
  return fetchWithRefresh(`${API_URL}/matches/load_match?area_id=${areaId}&categoria=${encodeURIComponent(categoria)}`);
}

export async function updateMatch({ vincitore, area_id, categoria }) {
  return fetchWithRefresh(`${API_URL}/matches/update_match`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ vincitore, area_id, categoria })
  });
}

export async function postpone({ vincitore, area_id, categoria }) {
  return fetchWithRefresh(`${API_URL}/matches/postpone`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ vincitore, area_id, categoria })
  });
}

export async function getMatchList() {
  return fetchWithRefresh(`${API_URL}/matches/lista-match`);
}

export async function getAllMatches() {
  return fetchWithRefresh(`${API_URL}/matches/allMatches`);
}

// Info Gala
export async function sendInfoGala(formData) {
  return fetchWithRefresh(`${API_URL}/info-gala/send-info-gala`, {
    method: "POST",
    body: formData, // ⚠️ FormData → niente Content-Type
  });
}

export async function resetAllData() {
  const token = getToken();

  const res = await fetch(`${API_URL}/scripts/reset`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || "Errore durante il reset");
  }

  return await res.blob(); // <-- restituisce il file ZIP
}

export async function sendAffiliazione(formData) {
  return fetchWithRefresh(`${API_URL}/affiliazione/register`, {
    method: "POST",
    body: formData,
  });
}

export async function getCategories() {
  return fetchWithRefresh(`${API_URL}/categories/`);
}

// AREE
export function getAree() {
  return fetchWithRefresh(`${API_URL}/areas/`);
}

export function addArea(data) {
  return fetchWithRefresh(`${API_URL}/areas/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function updateArea(id, data) {
  return fetchWithRefresh(`${API_URL}/areas/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function deleteArea(id) {
  return fetchWithRefresh(`${API_URL}/areas/${id}`, {
    method: "DELETE"
  });
}

// DISCIPLINE
export function getDiscipline() {
  return fetchWithRefresh(`${API_URL}/categories/`);
}

export function addDisciplina(data) {
  return fetchWithRefresh(`${API_URL}/categories/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function updateDisciplina(id, data) {
  return fetchWithRefresh(`${API_URL}/categories/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function deleteDisciplina(id) {
  return fetchWithRefresh(`${API_URL}/categories/${id}`, {
    method: "DELETE"
  });
}

// PARAMETRO DATA CHIUSURA ISCRIZIONI
export function getDataChiusuraIscrizioni() {
  return fetchWithRefresh(`${API_URL}/parameters/data-chiusura`);
}

export function setDataChiusuraIscrizioni(data) {
  return fetchWithRefresh(`${API_URL}/parameters/data-chiusura`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

// api.js - Aggiornamento funzione downloadPartecipantiCostiPDF
export async function downloadPartecipantiCostiPDF() {
  const token = getToken();
  const res = await fetch(`${API_URL}/scripts/abbinamenticosti-pdf`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const contentType = res.headers.get("content-type") || "";
  
  if (!res.ok) {
    // Se c'è un errore e il server ha mandato un messaggio JSON (es: 404 o 500)
    if (contentType.includes("application/json")) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.message || "Errore nel download PDF costi");
    }
    throw new Error("Errore del server durante la generazione del PDF");
  }

  // Se il server risponde 200 ma manda JSON (es. "Nessun abbinamento")
  if (contentType.includes("application/json")) {
    const data = await res.json();
    throw new Error(data.message || "Nessun dato disponibile");
  }

  // Ritorna il blob (ora è un PDF singolo)
  return res.blob();
}

export async function partecipantiPDF(sendEmail = false) {
  const token = getToken();
  const res = await fetch(`${API_URL}/scripts/report-partecipanti-palestre?send_email=${sendEmail}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const contentType = res.headers.get("content-type") || "";
  
  if (!res.ok) {
    if (contentType.includes("application/json")) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.message || "Errore nel download PDF partecipanti");
    } else {
      throw new Error("Errore nel download PDF partecipanti");
    }
  }

  // Se ritorna JSON (messaggio di nessun partecipante)
  if (contentType.includes("application/json")) {
    const data = await res.json();
    return data.data || "Nessun partecipante trovato";
  }

  // Altrimenti è un blob scaricabile
  return res.blob();
}

export async function downloadTabelloni() {
  const token = getToken();
  const res = await fetch(`${API_URL}/scripts/tabelloni`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const contentType = res.headers.get("content-type") || "";
  
  if (!res.ok) {
    if (contentType.includes("application/json")) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.message || "Errore nel download PDF tabelloni");
    } else {
      throw new Error("Errore nel download PDF tabelloni");
    }
  }

  // Se ritorna JSON (messaggio di nessun tabellone)
  if (contentType.includes("application/json")) {
    const data = await res.json();
    throw new Error(data.message || "Nessun abbinamento trovato");
  }

  // Altrimenti è un blob scaricabile
  return res.blob();
}

export function getIntervalloRefresh() {
  return fetchWithRefresh(`${API_URL}/parameters/intervallo-refresh`);
}

export function getParameters() {
  return fetchWithRefresh(`${API_URL}/parameters/`);
}

export function getParticipantsMessage() {
  return fetchWithRefresh(`${API_URL}/parameters/participants-message`);
}

// ===== PARAMETRI CRUD =====
export function addParameter(data) {
  return fetchWithRefresh(`${API_URL}/parameters/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function updateParameter(id, data) {
  return fetchWithRefresh(`${API_URL}/parameters/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
}

export function deleteParameter(id) {
  return fetchWithRefresh(`${API_URL}/parameters/${id}`, {
    method: "DELETE"
  });
}

// ===== GET lista matchings =====
export function getMatchings() {
  return fetchWithRefresh(`${API_URL}/matchings/`);
}

// ===== POST nuovo matching =====
export function addMatching(payload) {
  return fetchWithRefresh(`${API_URL}/matchings/`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" }
  });
}

// ===== PUT update matching =====
export function updateMatching(id, payload) {
  return fetchWithRefresh(`${API_URL}/matchings/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" }
  });
}

// ===== DELETE matching =====
export function deleteMatching(id) {
  return fetchWithRefresh(`${API_URL}/matchings/${id}`, {
    method: "DELETE"
  });
}

export const reorderMatches = (categoria, orderedIds) =>
  fetchWithRefresh(`${API_URL}/matches/reorder-match`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ categoria, ordered_match_ids: orderedIds }),
  })

export const addMatch = (payload) =>
  fetchWithRefresh(`${API_URL}/matches/add`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

export const deleteMatch = (matchId) =>
  fetchWithRefresh(`${API_URL}/matches/${matchId}`, { method: "DELETE" });

export const moveCategory = (payload) =>
  fetchWithRefresh(`${API_URL}/matches/move-category`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

export const updateSingleMatch = (id, payload) =>
  fetchWithRefresh(`${API_URL}/matches/single_match/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  
// ===== PASSWORD RECOVERY =====

/**
 * Invia la richiesta per ricevere il link di reset via email
 * @param {string} email 
 */
export async function forgotPassword(email) {
  const res = await fetch(`${API_URL}/auth/forgot-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  return handleResponse(res);
}


export async function resetPassword({ token, id, new_password }) { 
  const res = await fetch(`${API_URL}/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ 
      token, 
      id, 
      new_password 
    }),
  });
  return handleResponse(res);
}

export function getRankingWkaMarzo() {
  return fetchWithRefresh(`${API_URL}/dashboard/ranking/wka-marzo`);
}

export function getRankingGenerico(evento) {
  return fetchWithRefresh(`${API_URL}/dashboard/ranking?evento=${encodeURIComponent(evento)}`);
}

export function getListaEventi() {
  return fetchWithRefresh(`${API_URL}/dashboard/ranking/eventi`);
}